<template>
<div>
    <div class="selectTypeBox">
        <el-radio-group v-model="selectType" @change="onChangeSelectType">
            <el-radio-button label="成功"></el-radio-button>
            <el-radio-button label="确认付款"></el-radio-button>
        </el-radio-group>
    </div>

    <div class="itemList">
        <div class="itemDiv" v-for="(item, index) in dataList" :key="item.id">
            <div class="leftDiv">
                <P>{{item.realName}}，{{item.certification ? item.certification + ',' : ''}}{{item.bankName}},{{item.openBank}},{{item.bankNumber}}</P>
                <p>申请人手机号：{{item.withdrawalPhone}}，支付银行：{{item.payBank}}</p>
                <p>提现{{Number(item.orderAmount) + Number(item.serviceCharge)}}元(订单金额:{{item.orderAmount}},服务费用:{{item.serviceCharge}})</p>
                <p>提现时间：{{item.createTime}}</p>
                <p v-if="item.payNo && item.payNo !== ''"> 支付渠道：{{item.type === 1 ? '微信' : ''}}{{item.type === 2 ? '支付宝' : ''}}{{item.type === 3 ? '银行转帐' : ''}}{{item.type === 4 ? '现金' : ''}},单号：{{item.payNo}}</p>
                <div v-if="!item.payNo || item.payNo === ''">
                    <el-select v-model="item.payTypeInput" placeholder="支付类型"  style="width:300px">
                        <el-option v-for="items in options" :key="items.value" :label="items.label" :value="items.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="item.payBank" placeholder="支付银行"  style="width:300px">
                        <el-option v-for="items in bankOptions" :key="items.id" :label="items.value" :value="items.value">
                        </el-option>
                    </el-select>
                    <el-input placeholder="请输入支付流水号" v-model="item.payNoinput">
                    </el-input>
                    <el-date-picker
                    v-model="item.payTimeinput"
                    type="date"
                    placeholder="支付日期"
                    style="width:300px"
                    format="yyyy-MM-dd" 
                    value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                    <el-button type="success" @click="save1(item.id,index)" style="margin-left: 20px;">提交保存</el-button>
                </div>
            </div>
        </div>
    </div>
    <div class="block">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageNumber" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="pageTotal">
        </el-pagination>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span>是否保存该条提现记录</span>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false;save()">确 定</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
export default {
    name: 'txList',
    props: {},
    data() {
        return {
            positionName: '',
            pageSize: 20,
            pageNumber: 1,
            pageTotal: 0,
            dataList: [],
            dialogVisible: false,
            setid: '',
            setnum: '',
            selectType: '成功',
            selectTypeArray: {
                "成功": 1,
                "确认付款": 2
            },
            options: [{
                value: 1,
                label: '微信'
            }, {
                value: 2,
                label: '支付宝'
            }, {
                value: 3,
                label: '银行转帐'
            }, {
                value: 4,
                label: '现金'
            }],
            bankOptions: []
        }
    },
    watch: {
        inputV1: function () {
            this.inputV2 = Number(this.inputV1) * 10 * 18 / 100
        }
    },
    created: function () {},
    methods: {
          getBankList: function () {
            let that = this
            let data = {
            type: 'bankType'
            }
            axios({
                method: 'GET',
                url: Config.path + '/api/common/dict/getlist',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                params: data,
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.bankOptions = response.data.content
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        save1: function (id, num) {
            this.setid = id
            this.setnum = num
            this.dialogVisible = true
        },
        changePostionName: function () {
            this.pageNumber = 1
            this.getPositionLost()
        },
        getPositionLost: function () {
            let that = this
            let data = {
                status: this.selectTypeArray[this.selectType],
                pageSize: this.pageSize,
                pageNumber: this.pageNumber
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/withdrawal/getWithdrawalist',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                params: {},
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    let demo = response.data.content.list
                    for (let i in demo) {
                        demo[i].payNoinput = ''
                        demo[i].bankNameInput = ''
                    }
                    that.dataList = demo
                    that.pageTotal = response.data.content.total
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        handleCurrentChange: function (val) {
            this.pageNumber = val
            this.getPositionLost()
        },
        save: function () {
            let id = this.setid
            let index = this.setnum
            let that = this
            let data = {
                id: id,
                payNo: this.dataList[index].payNoinput,
                type: this.dataList[index].payTypeInput,
                putforwardDate: this.dataList[index].payTimeinput,
                payBank: this.dataList[index].payBank
            }
            axios({
                method: 'POST',
                url: Config.path + '/api/platform/withdrawal/confirmPayment',
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('token')
                },
                data: data
            }).then(function (response) {
                // eslint-disable-next-line
                console.log(response)
                if (response.data.success === '1') {
                    that.$message({
                        message: '保存成功',
                        type: 'warning'
                    });
                    that.getPositionLost()
                } else if (response.data.success === '111111') {
                    that.$router.push({
                        path: "/login"
                    });
                } else {
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                // eslint-disable-next-line
                console.log(error)
            })
        },
        onChangeSelectType(e) {
            this.pageSize = 20,
                this.pageNumber = 1,
                this.selectType = e
            this.getPositionLost()
        },
    },
    mounted: function () {
        this.getBankList();
        this.getPositionLost();
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.itemList {
    margin-top: 20px;
}

.itemList .itemDiv {
    background-color: #ffffff;
    width: 80%;
    margin: 0 auto 15px auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 25px;
    border-radius: 8px;
    min-height: 150px;
    box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
}

.itemList .itemDiv .leftDiv {
    width: 70%;
}

.itemList .itemDiv .leftDiv p {
    font-size: 18px;
    color: #757373;
}

.itemList .itemDiv .leftDiv>div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
}

.itemList .itemDiv .leftDiv>div>:nth-child(1) {
    width: 20%;
    margin-right: 20px;
}

.itemList .itemDiv .leftDiv>div>:nth-child(2) {
    margin-right: 20px;
}

.itemList .itemDiv .leftDiv>div :nth-child(1) input {
    width: 100%;
}

.itemList .itemDiv .rightDiv {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
}

.itemList .itemDiv .rightDiv p {
    font-size: 32px;
    color: #1AAD19;
    text-align: center;
}

.itemList .itemDiv .rightDiv div {
    padding: 30px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
}

.block {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
}
</style>
